import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MyRating from "./MyRating";
import { AIRTABLE_URL, AIRTABLE_HEADERS } from "./constants";


const MyRatingWrapper = () => {
  const { orderId } = useParams();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBooking = async () => {
      try {
       const res = await fetch(AIRTABLE_URL, {
        headers: AIRTABLE_HEADERS
        });

        const data = await res.json();

        const matched = data.records.find(
          (record) => record.fields.orderId?.trim() === orderId
        );

        if (matched) {
          setBooking({
            airtableRecordId: matched.id,
            ...matched.fields
          });
        } else {
          setBooking(null);
        }
      } catch (err) {
        console.error("Error fetching booking:", err);
        setBooking(null);
      } finally {
        setLoading(false);
      }
    };

    fetchBooking();
  }, [orderId]);

  if (loading) return <p>Loading booking data...</p>;
  if (!booking) return <p>Booking not found.</p>;

  return (
    <MyRating
      orderId={booking.orderId}
      technicianPhone={booking.assignedTechnicianPhone}
    />
  );
};

export default MyRatingWrapper;
